import { AuthenticatedRoute } from "../components/ProtectedRoute";

export default [AuthenticatedRoute];